import { render, staticRenderFns } from "./DeleteMiniIcon.vue?vue&type=template&id=4b9cb138"
import script from "./DeleteMiniIcon.vue?vue&type=script&lang=js"
export * from "./DeleteMiniIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports